import React from "react";
import "../css/ChooseUrSpaceDialog.css";
import headerAppIcon from "../../assets/images/header-sabehub-app-icon.svg";
import appTextLogo from "../../assets/images/quick-menu-app-text-logo.svg";
import createIcon from "../../assets/images/book-space-create-icon.svg";
import communicateIcon from "../../assets/images/book-space-communicate-icon.svg";
import inovateIcon from "../../assets/images/book-space-inovate-icon.svg";
import BottomSheet from "./BottomSheet";
import { useTabBar } from "services/TabBarProvider";
import { CALENDAR_RESERVATION_TYPE, MENU_ITEM } from "utils/constants";

interface ChooseUrSpaceDialogProps {
  open: boolean;
  onClose: () => void;
}

const ChooseUrSpaceDialog: React.FC<ChooseUrSpaceDialogProps> = ({
  open,
  onClose,
}) => {
  const { setSelectedTabBar } = useTabBar();

  const handleCreateSpaceClick = () => {
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.DF_WORKSPACE,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
    onClose();
  };

  const handleCommunicateSpaceClick = () => {
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.MEETING_ROOMS,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
    onClose();
  };

  const handleInovateSpaceClick = () => {
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.INNOVATE_SPACE,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
    onClose();
  };

  return (
    <BottomSheet open={open} onClose={onClose} height="90dvh">
      <div className="choose-ur-space-dialog-container">
        <div className="choose-ur-space-header-container">
          <div className="choose-ur-space-header-text-container">
            <span>
              Choose <span style={{ color: "white" }}>UR Space</span>
            </span>
          </div>
          <div className="choose-ur-space-header-container-divider"></div>
          <div className="choose-ur-space-header-button-container">
            <div
              className="choose-ur-space-header-container-button"
              onClick={onClose}
            >
              ✕
            </div>
          </div>
        </div>

        <div className="choose-ur-space-second-step-header-container">
          <span>
            Get <span style={{ fontWeight: "700" }}>Important</span> Work Done
            In A Day
          </span>
        </div>

        <div className="choose-ur-space-content-container">
          <div
            className="card-container first-shadow"
            onClick={handleCreateSpaceClick}
          >
            <img src={createIcon} alt="score-card-icon" />
            <div className="text-container">
              <span className="title">
                Create <span style={{ color: "#ff6b35" }}>Space</span>
              </span>
              <span className="sub-title">
                Book in 2-hour sessions for planning, brainstorming & creative
                work.
              </span>
            </div>
          </div>

          <div
            className="card-container first-shadow"
            onClick={handleInovateSpaceClick}
          >
            <img src={inovateIcon} alt="score-card-icon" />
            <div className="text-container">
              <span className="title">
                Innovate <span style={{ color: "#ff6b35" }}>Space</span>
              </span>
              <span className="sub-title">
                Book 4-hour deep work sessions for focused execution.
              </span>
            </div>
          </div>

          <div
            className="card-container first-shadow"
            onClick={handleCommunicateSpaceClick}
          >
            <img src={communicateIcon} alt="score-card-icon" />
            <div className="text-container">
              <span className="title">
                Communicate <span style={{ color: "#ff6b35" }}>Space</span>
              </span>
              <span className="sub-title">
                Book for 1–6 people for meetings, calls & collaboration.
              </span>
            </div>
          </div>
        </div>
        <div className="choose-ur-space-footer-container">
          <span>Powered By</span>
          <div className="sub-conatiner">
            <img
              src={headerAppIcon}
              alt="choose-ur-space-app-logo"
              className="footer-app-icon"
            />
            <img src={appTextLogo} alt="choose-ur-space-app-text-logo" />
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default ChooseUrSpaceDialog;
